// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3puSG","messages":"Chat_messages__I8TCG","dateDivider":"Chat_dateDivider__2Ey4R"};